import type {AppThunk} from '../../../actions/types'
import type {LoadedEndpoints} from '../../../routes/loadEndpoint'
import {isPipelinesAgentPageEnabled} from '../../../utils/featureToggles'
import {preloadAgentsOverviewPage} from '../../pages/AgentsPages/AgentsOverviewPage/AgentsOverviewPage.preload'

export const preloadAppAgentOverview = (): AppThunk<LoadedEndpoints> => dispatch => {
  if (isPipelinesAgentPageEnabled()) {
    return []
  }

  return dispatch(preloadAgentsOverviewPage())
}
